import { Component, OnInit, ViewChild,ViewChildren,QueryList } from '@angular/core';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../../organisms/organism.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as CommonConstants from '../../../utils/common.constants';
import { AddDepartmentComponent } from 'src/app/masters/add-department/add-department.component';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { PractitionersService } from '../practitioners.service';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
import { SharedService } from 'src/app/utils/shared.service';
import {CountryISO } from 'ngx-intl-tel-input';
@Component({
  selector: 'app-add-practitioner',
  templateUrl: './add-practitioner.component.html',
  styleUrls: ['./add-practitioner.component.scss']
})
export class AddPractitionerComponent implements OnInit {

  practitionerForm: FormGroup;
  organisms: OrganismModel[];
  nationalities: any[];
  categories: any[];
  categoryType:[];
  specialities: any[];
  subSpecialities: any[];
  hyperSpecialities: any[];
  certifications: any[];
  qualityCertifications: any[];
  professionList=[];
  gender: any[];
  civilities: any[];
  categoriesType:any[];
  submitted = false;
  today = new Date();
  partnerId: number;
  partnerType: number = CommonConstants.PARTNER_PRACTITIONER_TYPE;
  addPractionerTitle = true;
  editPractionerTitle;
  titles:any[];
  subSpecialitiesFiltered : any[];
  hyperSpecialitiesFiltered:any[];
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  townList: any;
  countryList: any;
  addressTypeList: any;

  constructor(private masterService: MasterService, private formBuilder: FormBuilder, 
    private practitionerService: PractitionersService, private toasterService : ToastrService, 
    private loaderService: LoaderService,private sharedService:SharedService) {
    this.getFromGroup();

  }

  ngOnInit() {
    this.loadMasterData();
  }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getNationality().subscribe(response => {
      if (response && response['result']) {
        this.nationalities = response['result'];
      }
    })

    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.categories =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })

    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoryType  =response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
      this.masterService.getHyperSpecialities().subscribe(response => {
        if (response && response['result']) {
          this.hyperSpecialities = response['result'];
        }
      })
    })
    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certifications = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.qualityCertifications = response['result'];
      }
    })
    this.masterService.getGender().subscribe(response => {
      if (response && response['result']) {
        this.gender = response['result'];
      }
    })
    this.masterService.getCivility().subscribe(response => {
      if (response && response['result']) {
        this.civilities = response['result'];
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoriesType  = response['result'];
      }
    })
    this.masterService.getTitle().subscribe(response => {
      if (response && response['result']) {
        this.titles  = response['result'];
      }
    })
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
    let searchCriteria={
      masterShName:'PROFESSION',
      master:{}
    }
    this.masterService.searchMaster(searchCriteria).subscribe(response => {
      this.professionList = response['result'];
    })
  }

  get f() { return this.practitionerForm.controls; }

  /**
    * Declare form group
    *  
    */
  private getFromGroup() {
    this.practitionerForm = this.formBuilder.group({
      'prtieId':[],
      'orgsmId': ['', Validators.required],
      'spltyId': new FormControl(),
      'ssptyId': new FormControl(),
      'hsptyId': new FormControl(),
      'civilCode': new FormControl(),
      'cotryIdNationality': new FormControl(),
      'gendeCode': new FormControl(),
      'titleId': new FormControl(),
      'persoVaFirstname': ['', Validators.required],
      'persoVaSecondName': new FormControl(),
      'persoVaThirdName': new FormControl(),
      'persoVaLastname': ['', Validators.required],
      'persoDtBirthDate': new FormControl(),
      'natioId': new FormControl(),
      'certiId': new FormControl(),
      'paCatId': new FormControl(),
      'pctypId': new FormControl(),
      'prtieVaFunctions': new FormControl(), 
      'persoVaEmail1': ['', Validators.email],
      'persoVaEmail2': ['', Validators.email],
      'persoVaMobilePhone1': new FormControl(),
      'persoVaMobilePhone2': new FormControl(),
      'persoVaHomePhone': new FormControl(),
      'persoVaWorkFax': new FormControl(),
      'persoVaWorkPhone': new FormControl(),
      'agmntId': new FormControl(),
      'professionalId': new FormControl(),
      'proposeFormation': [false],
      'pratiqueTelemedicine': new FormControl(),
      'staRecCode':[true]
      

    })
  }


  changeSpeciality(obj) {
    this.hyperSpecialitiesFiltered= [];
    this.practitionerForm.patchValue({ssptyId:null,hsptyId:null});
    this.subSpecialitiesFiltered = this.subSpecialities.filter(res => {
      return res.spltyId === obj.spltyId
    })
  }

  changeSubSpeciality(obj) {
    this.practitionerForm.patchValue({hsptyId:null});
    this.hyperSpecialitiesFiltered = this.hyperSpecialities.filter(res => {
      return res.ssptyId === obj.ssptyId
    })
  }
reset(){
  this.practitionerForm.reset();
}
  save() {
    this.submitted = true;
    if (this.practitionerForm.invalid) {
      return;
    }
    this.practitionerForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    let saveData = this.practitionerForm.value;
    this.phoneNos.forEach(phone => {
      saveData[phone.type]=phone.setPhoneNumberfrmInternation();
    })
    this.loaderService.display(true);
    this.practitionerService.save(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.practitionerForm.patchValue({prtieId: response['result']});
       // this.toasterService.success(response['message'], 'Success');
        swal.fire("Success", response['message'], 'success');
      }else{
        //this.toasterService.error(response['message'], 'Error');
        swal.fire("Error", response['message'], 'error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  loadPractitionerById(prtieId) {
    this.loaderService.display(true);
    this.practitionerService.getPractitionersById(prtieId).subscribe(response => {
      this.loaderService.display(false);
      this.hospDepartment.departmentList = [];
      this.hospAddress.addressList = [];
      if (response['code'] == 'S0000') {
        let result = response['result'];
        this.practitionerForm.patchValue({
          prtieId: result["prtieId"],
          orgsmId: result["orgsmId"],
          spltyId: result["spltyId"],
          gendeCode: result["gendeCode"] ? +result["gendeCode"] : [],
          ssptyId: result["ssptyId"],
          hsptyId: result["hsptyId"],
          civilCode: +result["civilCode"],
          cotryINationality: result["cotryINationality"],
          titleId: result["titleId"],
          persoVaFirstname: result["persoVaFirstname"],
          persoVaSecondName: result["persoVaSecondName"],
          persoVaThirdName: result["persoVaThirdName"],
          persoVaLastname: result["persoVaLastname"],
          persoDtBirthDate: result["persoDtBirthDate"] ? new Date(result["persoDtBirthDate"]) :null,
          natioId: result["natioId"],
          certiId: result["certiId"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          prtieDtFunctions: result["prtieDtFunctions"],
          persoVaEmail1: result["persoVaEmail1"],
          persoVaEmail2: result["persoVaEmail2"],
          persoVaMobilePhone1: result["persoVaMobilePhone1"],
          persoVaMobilePhone2: result["persoVaMobilePhone2"],
          persoVaHomePhone: result["persoVaHomePhone"],
          persoVaWorkFax: result["persoVaWorkFax"],
          persoVaWorkPhone: result["persoVaWorkPhone"],
          agmntId: result["agmntId"],
          professionalId: result["professionalId"],
          pratiqueTelemedicine: result["pratiqueTelemedicine"],
          staRecCode: result["staRecCode"] ==='A' ? true : false,
          prtieVaFunctions : result["prtieVaFunctions"]
          
        });
        alert("Reached:"+JSON.stringify(this.phoneNos));
        result['prAddressList'] = result['prAddressList'].map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
        this.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['prDepartmentList']));
        this.sharedService.setOrganismDepartment(this.hospDepartment.departmentList );
        this.hospAddress.addressList = JSON.parse(JSON.stringify(result['prAddressList']));
        alert("Reached:"+JSON.stringify(this.phoneNos));
        this.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
	
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  onChangeOrganism(event){
    if(event && event.cotryId){
      let country  =this.countryList.filter(type => type.cotryId == event.cotryId);
      this.phoneNos.forEach(phone => {
        phone.selectedCountry=country[0].cotryCode;
     })
    }else{
      this.phoneNos.forEach(phone => {
        phone.selectedCountry=CountryISO.France;
     })
    }
  }
}
